export enum QuestionsMode {
  GroupedScreeningQuestions,
  ReferralQuestions,
  Questionnaires,
}
